export enum ProductType {
  Ago = "Ago",
  Rms = "Rms",
  Pms = "Pms",
  B100 = "B100",
  Lfo = "Lfo",
  JetA1 = "JetA1",
  Slops = "Slops",
}
